<template>
  <!-- 返回顶部 -->
  <div class="lw-back-top" v-if="display" @click="$emit('toTopClick')">
    <!--    v-if="displayImg"-->
    <!--    @click="toTopClick"-->
    <img src="@/assets/images/question-bank-to-top.png">
  </div>
</template>

<script>
  export default {
    name: 'lwBackTop',
    props: {
      display: {
        type: Boolean,
        default: false,
      }
    },
    data () {
      return {
        src: '@/assets/images/question-bank-to-top.png',
      }
    }
  }
</script>
<style lang="scss" scoped>
  .lw-back-top {
    position: fixed;
    bottom: 110px;
    right: 14px;
    z-index: 1111;
    cursor: pointer
  }
</style>
